import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderTwo from "../components/HeaderTwo";
import HeroTwo from "../components/HeroTwo";
import AboutTwo from "../components/AboutTwo";
import ServiceThree from "../components/ServiceThree";
import WhyChoose from "../components/WhyChoose";
import PortfolioTwo from "../components/PortfolioTwo";
import TestimonialTwo from "../components/TestimonialTwo";
import CounterOne from "../components/CounterOne";
import TeamTwo from "../components/TeamTwo";
import ClientOne from "../components/ClientOne";
import EventOne from "../components/EventOne";
import PricingOne from "../components/PricingOne";
import AppointmentOne from "../components/AppointmentOne";
import CTATwo from "../components/CTATwo";
import BlogTwo from "../components/BlogTwo";
import AboutOne from "../components/AboutOne";
import BlogOne from "../components/BlogOne";
import Marquee from "react-fast-marquee";
import FooterOne from "../components/FooterOne";
import FooterFour from "../components/FooterFour";
import FooterFive from "../components/FooterThree";
import FooterTwo from "../components/FooterTwo";
import FooterThree from "../components/FooterThree";
import PortfolioThree from "../components/PortfolioThree";

const Home = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>
      {/* Preloader */}
      {active === true && <Preloader />}

      {/* Helmet */}
      <HelmetReact title={"Home"} />

      {/* HeaderTwo */}
      <HeaderTwo />

      {/* HeroTwo */}
      <HeroTwo />


      {/* ServiceThree */}
      <div className="space-top">
      <ServiceThree />
          
  </div>
  
  <AboutOne />
  
  <BlogOne />
    

      {/* WhyChoose */}
      <FooterThree />
    </>
  );
};

export default Home;
